/** 润度门户首页标识（与用户 homePage 字段对应） */
export const RUNDU_HOME_PATH = '/rundu/home'
export const RUNDU_MONITOR_PATH = '/rundu/monitor'
/** 兼容历史 homePage=rundu/monitor；新账号可写 rundu/home */
export const RUNDU_HOME_PAGE = 'rundu/home'
export const RUNDU_HOME_PAGE_ALIASES = ['rundu/home', 'rundu/monitor']
export const RUNDU_SUMMARY_PATHS = {
  operation: '/rundu/summary/operation',
  data: '/rundu/summary/data',
  alert: '/rundu/summary/alert',
}

/**
 * 润度账号专用页面映射：老菜单组件 → 新页面
 * 仅 isRunduPortal 时生效，不影响其它机构
 * key / value 均为 views/ 下相对路径（不含 .vue）
 */
export const RUNDU_VIEW_OVERRIDE = {
  'hardware/List/index': 'rundu/hardware/list/index',
}

/** 通用入口页：登录后应改走用户 homePage，不能被 redirect 盖住 */
export const ENTRY_HOME_PATHS = ['/', '/index', '/workbench/index']

/**
 * 是否润度门户用户：按 homePage 判断（rundu/home 或历史 rundu/monitor）。
 */
export function isRunduPortal(homePage) {
  const raw = String(
    homePage || sessionStorage.getItem('homePage') || ''
  )
    .trim()
    .replace(/^\/+/, '')
    .replace(/\/+$/, '')
  return RUNDU_HOME_PAGE_ALIASES.includes(raw) || raw.startsWith('rundu/')
}

/** @deprecated 请使用 isRunduPortal（按 homePage） */
export function isRunduDept() {
  return isRunduPortal()
}

export function isRunduRoute(path = '') {
  return path.startsWith('/rundu')
}

export function isRunduSummaryRoute(path = '') {
  return path.startsWith('/rundu/summary')
}

/** 润度账号加载视图时替换为新页面路径 */
export function resolveRunduView(view) {
  if (!view || !isRunduPortal()) return view
  return RUNDU_VIEW_OVERRIDE[view] || view
}

/**
 * 根据用户 homePage 解析登录后首页路由。
 */
export function resolveHomePath(homePage) {
  const raw = String(
    homePage ?? sessionStorage.getItem('homePage') ?? 'index'
  ).trim()
  if (!raw) return '/index'
  if (/^https?:\/\//i.test(raw)) return raw
  let path = raw.startsWith('/') ? raw : `/${raw}`
  // 历史 homePage=rundu/monitor 统一落到新首页
  if (path === RUNDU_MONITOR_PATH) return RUNDU_HOME_PATH
  return path
}

/**
 * 登录后落地页：优先用户 homePage；
 * 仅当 redirect 不是入口页时才跟 redirect（深链保留）。
 */
export function resolveLoginTarget(homePage, redirect) {
  const home = resolveHomePath(homePage)
  if (!redirect) return home
  const pathOnly = String(redirect).split('?')[0]
  const normalized = pathOnly.startsWith('/') ? pathOnly : `/${pathOnly}`
  if (ENTRY_HOME_PATHS.includes(normalized)) {
    return home
  }
  return normalized
}

/** 取侧栏第一个可访问业务菜单路径，供跳转 */
export function getFirstAdminPath(routes = []) {
  const skip = (p) =>
    !p || p === '/' || p.startsWith('/rundu') || p === '/index' || p === '/user/profile'

  const walk = (list, base = '') => {
    for (const route of list) {
      if (route.hidden) continue
      const fullPath = joinPath(base, route.path)
      if (route.children?.length) {
        const child = walk(route.children, fullPath)
        if (child) return child
      } else if (!skip(fullPath) && route.component) {
        return fullPath
      }
    }
    return null
  }

  return walk(routes) || '/index'
}

function joinPath(base, path) {
  if (!path) return base || '/'
  if (path.startsWith('http') || path.startsWith('/')) return path
  if (!base || base === '/') return `/${path}`
  return `${base.replace(/\/$/, '')}/${path}`
}
